.hero {
  position: relative;
  background: var(--color-primary-blue-100); /* PRIMARY_BLUE_100 */
  color: var(--color-primary-blue-900); /* PRIMARY_BLUE_900 */
  padding: 64px 0 84px;
  overflow: hidden;
}

/* accent rule at the bottom of the hero (solid in soft, tricolore in contrast) */
.hero::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 6px;
  background: var(--plume-hero-rule, var(--color-complementary-yellow));
}

.hero__inner {
  position: relative;
  display: grid;
  grid-template-columns: 1.25fr 1fr;
  align-items: center;
  gap: 48px;
}

.hero__breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 */
  margin-bottom: 30px;
}

.hero__breadcrumbTag {
  background: var(--color-primary-blue-900); /* PRIMARY_BLUE_900 */
  color: var(--color-primary-grey-000);
  padding: 5px 13px;
  border-radius: 9999px;
  letter-spacing: 0.06em;
}

.hero__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: non-standard fluid display size (up to 94px) — documented as a candidate future DS
     heading scale; larger than HEADING_3XL (76px). */
  font-size: clamp(46px, 7vw, 94px);
  line-height: 0.98;
  letter-spacing: -0.015em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 40px;
  text-wrap: balance;
}

.hero__titleHighlight {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-style: italic;
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.hero__art {
  /* let the oversized image bleed out via negative margin instead of widening the grid track */
  min-width: 0;
}

/* Bare hero illustration (mockup hero="bare"): no frame. Fills its column and scales with it so the
   whole illustration stays visible at every width — the earlier fixed rightward bleed cropped the
   right-hand subject on narrow (≤~1100px) screens. */
.hero__image {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
}

@media (max-width: 860px) {
  .hero__inner {
    grid-template-columns: 1fr;
  }

  .hero__art {
    display: none;
  }
}
